import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IOsaExecucaoFolhaTesteModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-incluir',
  templateUrl: './osa-execucao-aba-folha-teste-incluir.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-incluir.component.scss']
})
export class OsaExecucaoAbaFolhaTesteIncluirComponent implements OnInit {

  public model: IOsaExecucaoFolhaTesteModel = {} as IOsaExecucaoFolhaTesteModel;

  public osaExecucaoId: number = 0;
  public unidadeGestoraId: number = 0;
  public amostraId: number = 0;

  constructor(
    public matDialog: MatDialog,
    public osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteIncluirComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {

    this.osaExecucaoId = data?.osaExecucaoId;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.amostraId = data?.amostraId;
  }

  ngOnInit(): void {
    this.obter();
  }

  public obter() {

    this.osaExecucaoFolhaTesteService
      .obterUltimaFolhaTestePorExecucaoUnidadeGestoraAmostra(this.osaExecucaoId, this.unidadeGestoraId, this.amostraId)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.model.id = 0;
          this.model.amostraItemId = this.model.amostraItemId + 1;
          this.model.numeroFolha = this.model.numeroFolha + 1;
          this.model.amostraItemDescricao = '';
          this.model.origemPlanejamento = false;
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public salvar() {

    if (!this.model.amostraItemDescricao) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a descrição do ítem da amostra!",
      });
      return;
    }


    this.osaExecucaoFolhaTesteService
      .inserirFolhaTeste(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      }).finally(() => {
      });
  }


  public fechar() {
    this.dialogRef.close(false);
  }

}

